import { useState } from 'react';
import tripDestinationService from '../../../services/trips/trip-destination.service';

export interface IMoveDestinationModel {
  sourceTripId: string;
  sourceDestinationId: string;
  targetTripId: string;
  deleteAfterMove: boolean;
}

export const useMoveDestination = (
  onSuccess?: () => void,
  onError?: (error: any) => void
) => {
  const [loading, setLoading] = useState(false);

  const moveDestination = async (payload: IMoveDestinationModel) => {
    setLoading(true);
    try {
      if (payload.deleteAfterMove) {
        // Move destination (copy then delete from source)
        await tripDestinationService.moveDestinationsToTrip(
          payload.sourceTripId,
          payload.targetTripId,
          [payload.sourceDestinationId] // Pass as array
        );
      } else {
        // Copy destination (keep in source)
        await tripDestinationService.copyDestinationsToTrip(
          payload.sourceTripId,
          payload.targetTripId,
          [payload.sourceDestinationId] // Pass as array
        );
      }
      setLoading(false);
      if (onSuccess) onSuccess();
    } catch (error) {
      setLoading(false);
      if (onError) onError(error);
      else console.error('Error moving destination:', error);
    }
  };

  return {
    moveDestination,
    loading
  };
};
